<template>
    <slot v-bind="{
        ...state,
        setScroller,
    }" />
</template>

<script setup>
import { nextTick, onBeforeMount, onBeforeUnmount, reactive } from 'vue';
import { groupBy, sortBy, map } from 'lodash';

import { getUpcomingInstances } from '../services/inventory';
import favorites from '../services/favorites';
import { initialiseScroller } from '../modules/scroller';

const state = reactive({
    isLoading: true,
    events: [],
});

let groupedEvents;
let scroller;

const setScroller = element => {
    scroller = element;
}

const handleFavoritesChange = () => {
    const favoritePerformances = favorites.getFavoritePerformances().map(favorite => {
        return favorite.id;
    });

    const events = groupedEvents.filter(event => {
        return event.instances.some(instance => {
            return favoritePerformances.indexOf(parseInt(instance[0], 10)) !== -1;
        });
    });

    state.events = sortBy(events, event => {
        return +event.startDate;
    });
}

onBeforeMount(async () => {
    groupedEvents = await getUpcomingInstances().then(response => {
        return groupBy(response, 'event.id');
    });

    groupedEvents = map(groupedEvents, instances => {
        const event = instances[0].event;

        event.allow_favoriting = event.season?.attributes?.custom?.allow_favoriting;

        if (event.attributes?.custom?.allow_favoriting === 'Yes') {
            event.allow_favoriting = true;
        } else if (event.attributes?.custom?.allow_favoriting === 'No') {
            event.allow_favoriting = false;
        }

        event.instances = instances.map(instance => {
            return [ instance.tessitura.performanceId, instance.startDate, instance.allow_favoriting ];
        });

        return event;
    });

    handleFavoritesChange();

    state.isLoading = false;

    nextTick(() => {
        if (scroller) {
            initialiseScroller(scroller);
        }
    });

    window.addEventListener(favorites.favoritePerformancesChangedEventName, handleFavoritesChange);
});

onBeforeUnmount(() => {
    window.removeEventListener(favorites.favoritePerformancesChangedEventName, handleFavoritesChange);
});
</script>
